import React from 'react';
import trackEvent from 'services/AnalyticsService';
import Button from 'shared/components/Button/Button';
import myRACLogo from 'assets/images/logo/myrac.svg';
import styles from './CombinedLoginScreen.module.scss';

type Props = {
  loginCtaHandler: (_e: Event) => void,
  loginOneTimeEmailCtaHandler: (_e: Event) => void,
  registrationFormMyRacHandler: (_e: Event) => void,
}
const LoginTile = ({ loginCtaHandler, loginOneTimeEmailCtaHandler, registrationFormMyRacHandler }: Props) => {
  const loginPasswordMyRacHandler = (e: Event) => {
    loginCtaHandler(e);
    trackEvent('MyRAC_BreakdownLogin');
  };

  const loginOneTimeEmailMyRacHandler = (e: Event) => {
    loginOneTimeEmailCtaHandler(e);
    trackEvent('MyRAC_BreakdownLoginOneTimeEmail');
  };

  const loginRegistrationFormMyRacHandler = (e: Event) => {
    registrationFormMyRacHandler(e);
    trackEvent('MyRAC_BreakdownRegister');
  };

  return (
    <div className={styles.loginTileContainer}>
      <div className={styles.logoContainer}>
        <img src={myRACLogo} width="184px" alt="myRAC logo" />
      </div>
      <p className={styles.topContent} style={{ fontSize: '18px' }}>
        Check your policy dates and details for your RAC Breakdown Cover and Car Insurance. Plus, you can make changes to your breakdown policy in your online account.
      </p>
      <div className={styles.magicLinkContainer}>
        <h3 style={{ fontSize: '24px' }}>One-time login</h3>
        <p style={{ fontSize: '16px' }}>We&apos;ll email you a secure link. Just click the link to log in without a password.</p>
        <Button buttonStyles={{ fontSize: 24 }} boldTypography buttonText="Send me a link" onClickHandler={loginOneTimeEmailMyRacHandler} greyButton={undefined} darkGreyButton={undefined} outlineBlack={undefined} loading={undefined} />
      </div>
      <div className={styles.row}>
        <div className={styles.column}>
          <h3 style={{ fontSize: '24px' }}>Know your password?</h3>
          <p style={{ fontSize: '16px' }}>Use it to log in below.</p>
          <Button buttonStyles={{ fontSize: 24, backgroundColor: 'white', border: '2px solid #47474A', color: '#47474A' }} boldTypography buttonText="Log in" onClickHandler={loginPasswordMyRacHandler} greyButton={undefined} darkGreyButton={undefined} outlineBlack={undefined} loading={undefined} />
        </div>
        <div className={styles.column}>
          <h3 style={{ fontSize: '24px' }}>Don&apos;t have an account?</h3>
          <p style={{ fontSize: '16px' }}>Create your myRAC profile below.</p>
          <Button buttonStyles={{ fontSize: 24, fontFamily: 'FrederickSimmsBold', backgroundColor: 'white', color: '#47474A', border: '2px solid #47474A' }} boldTypography buttonText="Register" onClickHandler={loginRegistrationFormMyRacHandler} greyButton={undefined} darkGreyButton={undefined} outlineBlack={undefined} loading={undefined} />
        </div>
      </div>
    </div>
  )
}

export default LoginTile;
